/* @flow */

export const CONTRACTS_FETCH_REQUEST = 'CONTRACTS_FETCH_REQUEST';
export const CONTRACTS_FETCH_SUCCESS = 'CONTRACTS_FETCH_SUCCESS';
export const CONTRACTS_FETCH_FAILURE = 'CONTRACTS_FETCH_FAILURE';

export function success(payload) {
  return (dispatch) => {
    dispatch({
      type: CONTRACTS_FETCH_SUCCESS,
      payload,
    });
  };
}

export function failure(resource) {
  return (dispatch) => {
    dispatch({
      type: CONTRACTS_FETCH_FAILURE,
      payload: resource,
    });
  };
}

export default function fetch(params) {
  return (dispatch) => {
    dispatch({
      type: CONTRACTS_FETCH_REQUEST,
      payload: {
        params,
      },
    });
  };
}
